import { render, staticRenderFns } from "./ServiceDocumentation.vue?vue&type=template&id=4e70a130&scoped=true"
import script from "./ServiceDocumentation.vue?vue&type=script&lang=js"
export * from "./ServiceDocumentation.vue?vue&type=script&lang=js"
import style0 from "./ServiceDocumentation.vue?vue&type=style&index=0&id=4e70a130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e70a130",
  null
  
)

export default component.exports